<div
    class="st-icon-container"
    st-story-icon
    [title]="title()"
    [data]="data()"
    [itemType]="calculatedType()"
    [hasValue]="hasValue()"
    [hasBorder]="hasBorder()"></div>
